// Qué secciones de la home ve cada cuenta.
//
// Vive fuera de `EstiloMinimal.tsx` para poder testearse: ese archivo es la home entera
// —componentes, contexto, hooks de Supabase— y montarlo para verificar un `if` no es una
// opción. Acá adentro va sólo la DECISIÓN, sin React; el hook que la usa es un envoltorio
// de tres líneas.

import { isPaidPlan } from './planCapabilities';
import { rubroVePlantillas } from './rubro';

/**
 * ¿Se muestra "Creaciones recientes" en la home? —
 * ADR-2026-08-20-creaciones-recientes-se-esconde-solo-para-moda, que supersede a
 * ADR-2026-08-18-creaciones-recientes-solo-para-planes-pagos.
 *
 * La regla era "sólo planes pagos", a secas. Ahora el corte es **plan gratis Y rubro
 * Moda**: para el resto de los rubros la sección se ve también durante la prueba.
 *
 * ── El parpadeo, que es la mitad del problema ────────────────────────────────
 *
 * Las dos entradas resuelven async, así que el orden en que llegan decide qué ve el
 * usuario mientras tanto. Los dos defaults van para el mismo lado —ante la duda, NO se
 * muestra— porque los dos errores no cuestan igual: que a alguien la sección le aparezca
 * un instante tarde se nota poco; que se la muestren y se la saquen, mucho.
 *
 *   • **Plan desconocido cuenta como gratis.** Ya era así — ver `usePlanUsuario`.
 *   • **Rubro desconocido cuenta como Moda**, o sea esconde. Es la parte nueva: con el
 *     default contrario, un usuario gratis de Moda vería la sección mientras el rubro
 *     carga y la perdería al resolver.
 *
 * `rubroResuelto` es el `loaded` de `useRubroMarcaActiva` y se mira JUNTO con `rubro`, no
 * en lugar de él: ese hook arranca del cache de localStorage, así que en la segunda
 * visita el rubro ya se sabe en el primer paint aunque el fetch siga en vuelo. Con
 * `!rubroResuelto` a secas se descartaría ese cache y la sección volvería a esconderse un
 * instante en cada navegación — el mismo parpadeo, del otro lado.
 *
 * Una marca **sin rubro cargado** (`rubro` en `null` con el fetch ya resuelto) no es Moda,
 * así que ve la sección. Es el lado permisivo, y es coherente con el gating de modos, que
 * tampoco cae al rubro de la empresa (ADR-2026-07-31-modos-muebles-por-rubro-de-marca).
 *
 * @param plan          `company_profiles.plan`; `null` = todavía no se sabe.
 * @param rubro         Rubro de la MARCA activa; `null` = sin rubro, o no se sabe.
 * @param rubroResuelto `true` cuando el fetch del rubro terminó (aunque haya venido vacío).
 */
export function muestraCreacionesRecientes(
  plan: string | null | undefined,
  rubro: string | null | undefined,
  rubroResuelto: boolean,
): boolean {
  if (isPaidPlan(plan)) return true;
  // Prueba gratis: se esconde para Moda — y mientras no se sepa el rubro.
  if ((rubro ?? null) === null && !rubroResuelto) return false;
  return !rubroVePlantillas(rubro);
}
